const React = require("react");
// Using CommonJS syntax because of conditional require in the PluginCard Component

const CanvasSVG = props => (
  <svg
    className="logo"
    width="100%"
    height="100%"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: `evenodd`,
      clipRule: `evenodd`,
      strokeLinejoin: `round`,
      strokeMiterlimit: `2`,
    }}
  >
    <g transform="matrix(1,0,0,1,-60,-40)">
      <g transform="matrix(0.90566,0,0,0.941176,60,-0.470588)">
        <rect x="0" y="43" width="53" height="51" style={{ fill: `none` }} />
        <clipPath id="_clip1">
          <rect x="0" y="43" width="53" height="51" style={{ fill: `none` }} />
        </clipPath>
        <g clip-path="url(#_clip1)">
          <g id="Frame" transform="matrix(1.10417,0,0,1.0625,0,0.5)">
            <path
              d="M48,52L48,76C48,82.623 42.623,88 36,88L12,88C5.377,88 0,82.623 0,76L0,52C0,45.377 5.377,40 12,40L36,40C42.623,40 48,45.377 48,52Z"
              className="logo-frame"
              style={props ? { fill: props.color } : {}}
            />
            <path
              d="M46,52C46,46.481 41.519,42 36,42L12,42C6.481,42 2,46.481 2,52L2,76C2,81.519 6.481,86 12,86L36,86C41.519,86 46,81.519 46,76L46,52Z"
              className="logo-frame-fill"
              style={props ? { fill: props.backgroundcolor } : {}}
            />
          </g>

          <g
            id="Picture"
            transform="matrix(1.88048,-0.48486,0.503874,1.80952,-0.353426,56.1454)"
          >
            <g transform="matrix(1.2879,0.345092,-0.345092,1.2879,-36.6999,-20.3818)">
              <circle
                cx="42.5"
                cy="10.5"
                r="1.5"
                className="logo-color-transparency"
                style={
                  props ? { fill: props.color, fillOpacity: props.opacity } : {}
                }
              />
            </g>
            <g transform="matrix(1.2879,0.345092,-0.345092,1.2879,-36.6999,-20.3818)">
              <path
                d="M42.5,9C43.328,9 44,9.672 44,10.5C44,11.328 43.328,12 42.5,12C41.672,12 41,11.328 41,10.5C41,9.672 41.672,9 42.5,9ZM42.5,9.75C42.086,9.75 41.75,10.086 41.75,10.5C41.75,10.914 42.086,11.25 42.5,11.25C42.914,11.25 43.25,10.914 43.25,10.5C43.25,10.086 42.914,9.75 42.5,9.75Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
            <g transform="matrix(0.965926,0.258819,-0.258819,0.965926,-25.4195,-12.1829)">
              <path
                d="M34,14.4L37.381,12.371C37.756,12.146 38.23,12.166 38.585,12.423L41.605,14.607C41.939,14.848 42.379,14.882 42.745,14.694L49,11.485L49,16.131C49,17.163 48.163,18 47.131,18L35.869,18C34.837,18 34,17.163 34,16.131L34,14.4Z"
                className="logo-color-transparency"
                style={
                  props ? { fill: props.color, fillOpacity: props.opacity } : {}
                }
              />
            </g>
            <g transform="matrix(1.03492,0.277306,-0.305877,1.14155,-26.9183,-15.9726)">
              <path
                d="M48,8.713L48,16.767C48,17.712 47.153,18.48 46.111,18.48L35.889,18.48C34.847,18.48 34,17.712 34,16.767L34,8.713C34,7.768 34.847,7 35.889,7L46.111,7C47.153,7 48,7.768 48,8.713ZM47.067,8.713C47.067,8.235 46.638,7.846 46.111,7.846L35.889,7.846C35.362,7.846 34.933,8.235 34.933,8.713L34.933,16.767C34.933,17.245 35.362,17.634 35.889,17.634L46.111,17.634C46.638,17.634 47.067,17.245 47.067,16.767L47.067,8.713Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
            <g transform="matrix(0.965926,0.258819,-0.258819,0.965926,-25.4195,-12.1829)">
              <path
                d="M34.861,14.693L34.307,13.861L37.09,12.005C37.644,11.636 38.369,11.65 38.909,12.04L41.898,14.202C42.079,14.333 42.318,14.351 42.517,14.249L48.401,11.231L48.857,12.121L42.974,15.139C42.44,15.412 41.798,15.363 41.312,15.012L38.323,12.85C38.122,12.705 37.852,12.7 37.645,12.838L34.861,14.693Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
          </g>
          <g
            id="CropMarks"
            transform="matrix(1.94682,0,0,1.87336,4.11157,47.4877)"
          >
            <g transform="matrix(-1,1.22465e-16,-1.22465e-16,-1,53,23)">
              <path
                d="M32,6L32,2L36,2L36,3L33,3L33,6L32,6Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
            <g transform="matrix(-1.83697e-16,-1,1,-1.83697e-16,0,53)">
              <path
                d="M32,6L32,2L36,2L36,3L33,3L33,6L32,6Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
            <g transform="matrix(6.12323e-17,1,-1,6.12323e-17,23,-30.5672)">
              <path
                d="M32,6L32,2L36,2L36,3L33,3L33,6L32,6Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
            <g transform="matrix(1,0,0,1,-30,-0.567164)">
              <path
                d="M32,6L32,2L36,2L36,3L33,3L33,6L32,6Z"
                className="logo-color"
                style={props ? { fill: props.color } : {}}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

exports.Logo = CanvasSVG;
